module.exports = __webpack_public_path__ + "img/jt_bank.6b797637.png";